<template>
    <div>
        <modal
            :name="modalName"
            height="auto"
            :classes="['v--modal', 'vue-dialog', 'ccs--modal', 'vue-dialog-borders', this.params.class]"
            :width="width"
            :pivot-y="0.3"
            :adaptive="true"
            :click-to-close="clickToClose"
            :transition="transition"
            :scrollable="true"
            :closeOnEnter="closeOnEnter"
            :show_icon="show_icon"
            :show_header="show_header"
            :header_text="header_text"
            @before-open="beforeOpened"
            @before-close="beforeClosed"
            @opened="$emit('opened', $event)"
            @closed="$emit('closed', $event)"
        >
            <div class="dialog-content">
                <div class="c-box__header">
                    <h3 class="c-box__title mb-5" v-if="show_header">{{header_text}}</h3>
                    <button class="dialog-c-close c-btn float-right" @click="$modal.hide(modalName)">
                        <span class="ccs-table__icon icon-delete-ccs icon-ccs"></span>
                    </button>
                </div>
                <div class="icon-type" v-if="show_icon">
                    <div class="c-modal-icon c-modal-icon--info" v-if="shouldShow('info')">
                        <fa :icon="['far', 'info-square']"></fa>
                    </div>
                    <div class="c-modal-icon c-modal-icon--error" v-if="shouldShow('error')">
                        <fa :icon="['far', 'times-square']"></fa>
                    </div>
                    <div class="c-modal-icon c-modal-icon--success" v-if="shouldShow('success')">
                        <fa :icon="['fas', 'check']"></fa>
                    </div>
                    <div class="c-modal-icon c-modal-icon--warning" v-if="shouldShow('warning')">
                        <fa :icon="['far', 'exclamation-square']"></fa>
                    </div>
                </div>
                <div class="dialog-c-title" v-if="params.title" v-html="params.title"></div>
                <div class="dialog-c-text" v-html="params.text || ''"></div>
                <div class="dialog-c-text"><slot name="content"></slot></div>
                <b-alert
                    :show="responseMessage.isVisible"
                    :variant="responseMessage.type"
                    dismissible
                    @dismissed="responseMessage.isVisible = false"
                    fade
                >
                    <h5 class="alert-heading">{{ responseMessage.title }}</h5>
                    {{ responseMessage.message }}
                </b-alert>
            </div>
            <div class="vue-dialog-buttons" v-if="show_buttons && buttons">
                <button
                    v-for="(button, i) in buttons"
                    :class="button.class || 'vue-dialog-button'"
                    type="button"
                    :style="buttonStyle"
                    :key="i"
                    :disabled="loadingRequest === true"
                    @click.stop="click(i, $event)"
                >
                    {{ loadingRequest === true ? "Loading..." : button.title }}
                </button>
            </div>
            <div v-else class="vue-dialog-buttons-none"></div>
        </modal>
    </div>
</template>
<script>
export default {
    props: {
        width: {
            type: [Number, String],
            default: 400
        },
        closeOnEnter: {
            type: Boolean,
            default: true
        },
        clickToClose: {
            type: Boolean,
            default: true
        },
        show_icon: {
            type: Boolean,
            default: true
        },
        show_buttons: {
            type: Boolean,
            default: true
        },
        show_header: {
            type: Boolean,
            default: false
        },
        header_text: {
            type: String,
            default: ''
        },
        transition: {
            type: String,
            default: "fade"
        },
        loadingRequest: {
            type: Boolean,
            default: false
        },
        responseMessage: {
            type: Object,
            default: () => {
                return {
                    type: "danger",
                    title: "Error",
                    message: "An error has occurred.",
                    isVisible: false
                };
            }
        }
    },
    data() {
        return {
            params: {},
            defaultButtons: [{ title: "CLOSE" }]
        };
    },
    computed: {
        modalName() {
            let name = this.$options._componentTag;
            return name + "-dialog";
        },
        buttons() {
            return this.params.buttons || this.defaultButtons;
        },
        /**
         * Returns FLEX style with correct width for arbitrary number of
         * buttons.
         */
        buttonStyle() {
            return {
                flex: `1 1 ${100 / this.buttons.length}%`
            };
        }
    },
    methods: {
        shouldShow(type) {
            let t = this.params.type;
            if (typeof t === "undefined") {
                t = "info";
            }
            return t === type;
        },
        beforeOpened(event) {
            window.addEventListener("keyup", this.onKeyUp);

            this.params = event.params || {};
            this.$emit("before-opened", event);
        },
        beforeClosed(event) {
            window.removeEventListener("keyup", this.onKeyUp);

            this.params = {};
            this.$emit("before-closed", event);
        },
        click(i, event, source = "click") {
            const button = this.buttons[i];

            if (button && typeof button.handler === "function") {
                button.handler(i, event, { source });
            } else {
                this.$modal.hide(this.modalName);
            }
        },
        onKeyUp(event) {
            if( !this.closeOnEnter ) return;
            if (event.which === 13 && this.buttons.length > 0) {
                const buttonIndex = this.buttons.length === 1 ? 0 : this.buttons.findIndex((button) => button.default);

                if (buttonIndex !== -1) {
                    this.click(buttonIndex, event, "keypress");
                }
            }
        }
    },
    mounted() {}
};
</script>
<style lang="scss" scoped>
@import "../sass/base/config";
@import "../sass/base/bootstrap";

// i hate scss import handling for legacy
@mixin text-colors($map) {
    @each $theme, $color in $map {
        &--#{$theme} {
            color: $color;
        }
    }
}
@function em($target, $context: $base__font-size) {
    @return ($target / $context) * 1em;
}

.vue-dialog {
    box-shadow: 0 5px 5px -2px rgba(27, 33, 58, 0.1) !important;
    border-radius: 5px;
}

.vue-dialog-borders {
    border-radius: 5px;
}

.vue-dialog div {
    box-sizing: border-box;
}

.vue-dialog .dialog-flex {
    width: 100%;
    height: 100%;
}

.vue-dialog .alert {
    margin-bottom: 0;
    margin-top: 1rem;
}

.vue-dialog .dialog-content {
    flex: 1 0 auto;
    width: 100%;
    padding: 25px;
    word-break: break-word;
}

.vue-dialog .dialog-c-title {
    font-weight: 600;
    padding-bottom: 15px;
    font-size: 16px;
}

.vue-dialog .vue-dialog-buttons {
    display: flex;
    flex: 0 1 auto;
    width: 100%;
    border-top: 1px solid #eee;
}

.vue-dialog .vue-dialog-buttons-none {
    width: 100%;
    padding-bottom: 15px;
}

.vue-dialog .dialog-c-close {
    position: absolute;
    top: 0;
    right: 0;
}

.vue-dialog-button {
    font-size: 12px !important;
    background: transparent;
    padding: 0;
    margin: 0;
    border: 0;
    cursor: pointer;
    box-sizing: border-box;
    line-height: 40px;
    height: 40px;
    color: inherit;
    font: inherit;
    outline: none;
}

.vue-dialog-button:hover {
    background: rgba(0, 0, 0, 0.01);
}

.vue-dialog-button:active {
    background: rgba(0, 0, 0, 0.025);
}

.vue-dialog-button:not(:first-of-type) {
    border-left: 1px solid #eee;
}

.c-modal-icon {
    text-align: center;
    font-size: em($base__font-size * 4);
    margin-bottom: 25px;

    @include text-colors($ui-colors);
}
</style>
